export const DEFAULT_ERROR_MESSAGE =
  "Sorry, something went wrong. An error has occurred on the server";
export const EMAIL_EXISTS_ERROR_MESSAGE =
  "This email is already in use.";
